import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AnalysisApiClient, isNkHttpError } from '@nk/api-client-lib';
import { CachingService } from '@nk/caching-lib';
import { AppFeatureKey, AppRoleKey, CustomerPersonCompositeEntity, CustomerPersonEntity } from '@nk/data-entities-lib';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class CustomerPersonService {
  constructor(
    private _analysisApi: AnalysisApiClient,
    private _cachingService: CachingService,
    private _router: Router,
  ) {}

  public customerPersonCache = this._cachingService.create(this, this.fetchCustomerPerson);
  public fetchCustomerPerson(
    screeningConfigUuid: string,
    customerPersonUuid: string,
  ): Observable<CustomerPersonEntity> {
    return this._analysisApi.get<CustomerPersonEntity>(
      `/screening-config/${screeningConfigUuid}/customer-person/${customerPersonUuid}`,
      {},
      [AppFeatureKey.base, AppFeatureKey.screening],
      [AppRoleKey.aml],
    );
  }

  public customerPersonCompositeCache = this._cachingService.create(this, this.fetchCustomerPersonComposite);
  public fetchCustomerPersonComposite(
    screeningConfigUuid: string,
    customerPersonUuid: string,
  ): Observable<CustomerPersonCompositeEntity> {
    return this._analysisApi
      .get<CustomerPersonCompositeEntity>(
        `/screening-config/${screeningConfigUuid}/customer-person-composite/${customerPersonUuid}`,
        {},
        [AppFeatureKey.base, AppFeatureKey.screening],
        [AppRoleKey.aml],
      )
      .pipe(
        catchError((error: unknown) => {
          if (isNkHttpError(error) && error.status === 404) {
            void this._router.navigate(['/404']);
          }
          return throwError(() => error);
        }),
      );
  }
}
